<template>
  <div class="fullscreen-bg">
    <button class="back-button" @click="goBack">
    </button>
  </div>
</template>

<script>
export default {
  methods: {
    goBack() {
      if (this.$router) {
        this.$router.go(-1);
      } else {
        window.history.back();
      }
    }
  }
}
</script>

<style scoped>
.fullscreen-bg {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url('~@/assets/recycling/index/management-page-bg.png');
  background-size: 100% 100%; /* 改为100%宽度和高度，实现拉伸效果 */
  background-position: center center;
  background-repeat: no-repeat;
}

.back-button {
  position: absolute;
  top: 0px;
  left: 0;
  width: 180px;
  height: 100px;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  z-index: 10;
  font-size: 14px; /* 为文字添加样式 */
  color: #333; /* 文字颜色 */
}

</style>
